// Base
import Script from 'next/script'

// Trackers
import { gtag, ttpixel } from '@helpers/trackers'

const Vendors = () => {
  return (
    <>
      <Script
        id="gtag"
        src={`https://www.googletagmanager.com/gtag/js?id=${gtag.TRACKING_ID}`}
      />
      <Script id="GA4">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gtag.TRACKING_ID}');
          gtag('config', '${gtag.GOOGLE_ADS_ID}');
        `}
      </Script>
      <Script id="hotjar">
        {`
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${process.env.NEXT_PUBLIC_HOTJAR_ID},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <Script
        id="plausible"
        data-domain="premium.ratepunk.com"
        src="https://plausible.io/js/script.js"
      />

      <Script type="text/javascript" id="vwoCode">
        {`
          window._vwo_code=window._vwo_code || (function() {
          var account_id=553434,
          version = 1.5,
          settings_tolerance=4000,
          library_tolerance=4500,
          use_existing_jquery=false,
          is_spa=1,
          hide_element='body',
          hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
          /* DO NOT EDIT BELOW THIS LINE */
          f=false,w=window,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='high';t.src=e;t.type='text/javascript';t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)\s?(_vis_opt_exp_\d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_\d+_combi=(?:\d+,?)+\s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([\d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;w.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.currentScript,t=d.createElement('style'),i=e&&!e.async?hide_element?hide_element+'{'+hide_element_style+'}':'':code.lA=1,n=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&t.setAttribute('nonce',vwoCodeEl.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));n.appendChild(t);var o=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(o?'&c='+o:''));return settings_timer}};w._vwo_settings_timer = code.init();return code;}());
        `}
      </Script>
      <Script id="pinterest">
        {`
          !function(e){if(!window.pintrk){window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
              n=window.pintrk;n.queue=[],n.version="3.0";var
              t=document.createElement("script");t.async=!0,t.src=e;var
              r=document.getElementsByTagName("script")[0];
              r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
            pintrk('load', '${process.env.NEXT_PUBLIC_PINTEREST_TAG_ID}');
            pintrk('page');
        `}
      </Script>
      <Script id="newsbreak-pixel">
        {`!(function (e, n, t, i, p, a, s) {
          e[i] ||
            (((p = e[i] =
              function () {
                p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);
              }).queue = []),
            (p.t = +new Date()),
            ((a = n.createElement(t)).async = 1),
            (a.src = 'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' + 864e5 * Math.ceil(new Date() / 864e5)),
            (s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s));
        })(window, document, 'script', 'nbpix'),
          nbpix('init', '${process.env.NEXT_PUBLIC_NBPIX_ID}'),
          nbpix('event', 'pageload');`}
      </Script>
    </>
  )
}

export default Vendors
